<template>
<div class="container-fluid p-4">
	<vue-form v-on:submit="registerSave" size="xsm" :no-top-button="true" save-button-text="Register" class="register-form" :working="working">
		<div class="logo">
			<img :src="logoSrc">
		</div>

		<h1 class="text-center mt-4">Register for {{$store.appName}}</h1>

		<field label="Company Name"
			col-class="col-md-4"
			v-model="payload.company_name">
		</field>

		<field label="First Name"
			col-class="col-md-4"
			v-model="payload.first_name">

		</field>

		<field label="Last Name"
			col-class="col-md-4"
			v-model="payload.last_name">

		</field>

		<field label="Phone"
			col-class="col-md-4"
			v-model="payload.phone">

		</field>

		<field label="Email Address"
			col-class="col-md-4"
			v-model="payload.email">

		</field>

		<field label="Password"
			col-class="col-md-4"
			v-model="payload.password"
			:params="{type:'password'}">

		</field>

		<div class="offscreen">
			<label>All biological organisms please leave this field blank</label>
			<input type="text" name="biologyCheck" v-model="payload.biologyCheck">
		</div>

		<alert :visible="showErrorAlert" classes="alert-danger" :errors="errors" :unclosable="true"></alert>


	</vue-form>

	<modal-dialog title="Continue to Login"
		modal-size="modal-sm"
		:modal-visible="continueToLoginModal.visible"
		confirm-button-text="Take me to Log-in"
		v-on:closeModal="continueToLoginModal.visible = false"
		v-on:confirm="goToLogin">

		<p>You have successfully registered! Please check your email for a verification link, and then proceed to the login page</p>

	</modal-dialog>
</div>
</template>
<script type="text/javascript">
import Field from "@/components/Field"
import VueForm from "@/components/VueForm"
import Alert from "@/components/Alert"
import ModalDialog from "@/components/ModalDialog"

export default {
	components: {
		Field,
		VueForm,
		Alert,
		ModalDialog
	},
	data() {
		return {
			payload: {
				company_name: "",
				first_name: "",
				last_name: "",
				email: "",
				phone: "",
				password: "",
				biologyCheck: ""
			},
			working: false,
			showErrorAlert: false,
			errors: [],
			continueToLoginModal: {
				visible: false
			}
		}
	},
	computed: {
		logoSrc() {
			return window.apiRoot+"resources/logo.png"
		}
	},
	methods: {
		registerSave() {
			let vm = this

			this.working = true

			this.postData("User/signup",this.payload).then(response => {
				vm.working = false

				if (response.success) {
					vm.continueToLoginModal.visible = true
				}
				else if ("errors" in response) {
					let errors = []
					Object.keys(response.errors).forEach(key => {
						errors.push(response.errors[key])
					})

					vm.errors = errors
					vm.showErrorAlert = true
				}
			})
		},
		goToLogin() {
			this.$bus.$emit('logout')
		}
	}
}
</script>

<style type="text/css">
	.register-form {
		margin-top: 20px!important;
	}

	.offscreen {
		position: fixed;
		left: -1000px;
	}
</style>